
import React from "react";

import { Grid } from '@mui/material';

import { Select } from "../../../../componentsv2/Select";

export default function SelectManifestacao({
  onChange,
  value,
  disabled = false,
  required = false,
  todas = false
}) {
  const options =["Reclamação", "Sugestão", "Elogio", "Solicitação"];
  todas && options.unshift("Todas");
  return (
    <>
      <Grid container spacing={1} justify="center" alignItems="stretch">
        <Grid item xs={12}>
          <Select
            disabled={disabled}
            required={required}
            onChange={onChange}
            value={value}
            label="Tipo de Manifestação"
            arrayOptions={options}
            variant="standard"
            />
        </Grid>
      </Grid>
    </>
  );
}


